<template>
  <el-dialog title="下载成功" :visible.sync="isShowDownloadSuccess"  :before-close="() => $emit('close')" width="500px">
    <div style="font-size: 14px;font-weight: bold;color: #333;margin-bottom: 20px;text-align: center;">下载任务提交成功</div>
    <div style="font-size: 14px;color: #333;margin-bottom: 10px;text-align: center;">请前往系统管理-下载中心查看并下载数据</div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">稍后查看</el-button>
      <el-button type="primary" @click="$emit('config')">立即查看</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    // 弹窗显示控制
    isShowDownloadSuccess: {
      type: Boolean,
      default: false
    },
  },
  name: 'GlobalDialogTable',
  data() {
    return {
    }
  },
  methods: {


  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss"></style>
